var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", [
        _c("div", { staticClass: "tlive-create__student--contain" }, [
          _c(
            "div",
            {
              staticClass: "tlive-create__student--choose",
              on: { click: _vm.showDialog },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.value.length
                      ? _vm.$t(
                          "pc_biz_personSpecified",
                          [_vm.value.length] /*  已指定{0}人 */
                        )
                      : _vm.$t("pc_biz_hasNoChoseStudents" /* 未选择指定人员 */)
                  ) +
                  "\n      "
              ),
            ]
          ),
          _c("span", { staticClass: "tlive-create__tip" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "pc_biz_designatedWatchTips" /* 指定人员通过分享链接或从“直播广场”观看 */
                  )
                ) +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _vm.value.length
        ? _c(
            "div",
            { staticClass: "tlive-create__student--list" },
            [
              _c("check-list", {
                attrs: { data: _vm.value },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(scope.list, function (user) {
                          return _c(
                            "yxt-tag",
                            {
                              key: user.id,
                              attrs: {
                                size: "small",
                                closable: "",
                                type: "info",
                              },
                              on: {
                                close: function ($event) {
                                  return _vm.deleteUserNames(user.id)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                [
                                  _c("yxtbiz-user-name", {
                                    attrs: { name: user.fullname },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  3397248722
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "yxt-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.chooseLoading,
              expression: "chooseLoading",
            },
          ],
          attrs: {
            "before-close": _vm.onStudentBeforeClose,
            "header-border": false,
            "destroy-on-close": true,
            size: "960px",
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("yxt-user-selector", {
            ref: "selector",
            attrs: {
              data: _vm.value,
              tabs: _vm.tabs,
              "function-code": _vm.isGroupOrg
                ? "group_task_center"
                : "tlive_mgmt_list",
              "data-permission-code": _vm.isGroupOrg
                ? "task_manage_platform"
                : "tlive_mgmt_extent",
              enableGroupCorp: _vm.isGroupOrg,
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("pc_biz_core_btn_cancel" /* 取消 */)) +
                      "\n        "
                  ),
                ]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.getUsers("student")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("pc_biz_core_btn_determine" /* 确认 */)) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }